import { getHostKeyBySite } from '../localisation/getHostKeyBySite/getHostKeyBySite';
import { isDevelopmentRuntime } from '../runtime/env';

export interface TranslationObject {
    [key: string]: string;
}
// transformRelativeURLtoAbsoluteURL() iterates over all translated URLs and ensures it prefixes
// paths with it's correct host. This is to ensure that all URLs are absolute values.
// In some instances where translated URLs are prefixed with a language (e.g. `/fr/`), those languages will
// be stripped when fetched resulting in invalid paths. Ensuring they are all absolute works around this issue.
export function transformRelativeURLtoAbsoluteURL(
    hostUrlKey: 'vistaprint.com' | '99designs.com',
    urls: TranslationObject
) {
    const urlMap = new Map<string, string>(Object.entries(urls));
    const hostUrlValue = urlMap.get(getHostKeyBySite(hostUrlKey));
    const ignoredUrlKeys = ['vistaprint.com', '99designs.com', 'staging.vistaprint.com', 'dev'];

    urlMap.forEach((val, key, map) => {
        // no processing required for the host URL as it's already an absolute URL
        if (ignoredUrlKeys.includes(key)) {
            return;
        }

        if (isDevelopmentRuntime()) {
            map.set(key, `http://localhost:3000${val}`);
            return;
        }

        // prefixing paths with the host assumes that the path begins with a forward slash
        if (val[0] !== '/') {
            // eslint-disable-next-line no-throw-literal
            throw `URL value: ${val} is missing a beginning forward slash`;
        }

        map.set(key, `${hostUrlValue}${val}`);
    });

    return Object.fromEntries(urlMap);
}
